<template>
    <!-- 课时编辑 -->
    <el-dialog custom-class="dialogForm" class="measDialog scheduleDialog" :visible.sync="visible" :before-close="handleClose" :close-on-click-modal="false" width="80%" :title="title">
        <el-scrollbar class="dialogContentScroll">
            <div class="scheduleConte">
                <div class="formContent">
                    <el-form :model="form" ref="form" :rules="rules">
                        <div class="formItemBox mb-15">
                            <el-form-item label="班级名称" prop="">
                                <el-input :disabled="true" v-model="initData.className" maxlength="100" placeholder="班级名称"></el-input>
                            </el-form-item>
                            <el-form-item label="课程名称" prop="">
                                <el-input :disabled="true" v-model="initData.courseName" maxlength="100" placeholder="课程名称"></el-input>
                            </el-form-item>
                        </div>
                        <div class="formItemBox mb-15">
                            <el-form-item label="课时序号" prop="">
                                <el-input :disabled="true" v-model="initData.courseIndex" maxlength="100" placeholder="课时序号"></el-input>
                            </el-form-item>
                            <el-form-item label="课时名称" prop="periodname">
                                <el-input v-model="form.periodname" maxlength="100" placeholder="课时名称"></el-input>
                            </el-form-item>
                        </div>
                        <div class="formItemBox mb-15">
                            <el-form-item label="授课日期" prop="perioddate">
                                <el-date-picker value-format="yyyy-MM-dd" v-model="form.perioddate" type="date" placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="授课时间" prop="">
                                <el-select v-model="timeArr" multiple placeholder="请选择">
                                    <el-option v-for="item in timeOptions" :key="item.code" :label="item.timeStr" :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="formItemBox mb-15">
                            <el-form-item label="授课模式" prop="periodmode">
                                <el-radio v-model="form.periodmode" :label="1">线上</el-radio>
                                <el-radio v-model="form.periodmode" :label="2">线下</el-radio>
                            </el-form-item>
                            <el-form-item label="内容形式" prop="contentway">
                                <el-radio v-model="form.contentway" :label="1">录播</el-radio>
                                <el-radio v-model="form.contentway" :label="2">直播</el-radio>
                            </el-form-item>
                        </div>

                        <div class="formItemBox mb-15 ai-c" v-if="form.contentway === 1">
                            <el-form-item label="录播课程" prop="enddate">
                                <SelectPage :listLoading="false" key="1" @getSelectValue="getSelectClassVideo" label="name" value="code" 
                                :initData="initClassVideoDate" @changePageGetList="changePageGetListVideo" :list="classVideoDate" :isMultiple="false" 
                                :paginationOption="paginationOptionCourse" :remoteStatus="true" :filterableStatus="true" @searchValue="searchValueVideo" />
                            </el-form-item>
                            <span v-if="playUrl" class="ylBtn">预览</span>
                        </div>
                        <div class="formItemBox mb-15">
                            <el-form-item label="授课老师" prop="teachername">
                                <SelectPage key="2" :listLoading="false" @getSelectValue="getSelectValue" label="orgname" value="code" 
                                :initData="initTeacherData" @changePageGetList="changePageGetListTeach" :list="teachOptions" :isMultiple="true" 
                                :paginationOption="paginationOptionTeach" :remoteStatus="true" :filterableStatus="true"/>
                            </el-form-item>
                        </div>
                        <div class="formItemBox mb-15">
                            <el-form-item label="授课内容" prop="content">
                                <el-input type="textarea" :rows="2" maxlength="200" placeholder="请输入内容" v-model="form.content">
                                </el-input>
                            </el-form-item>
                        </div>
                        <div class="formItemBox mb-15">
                            <el-form-item label="课件信息">
                                <SelectPage key="3" :listLoading="false" @getSelectValue="getSelectCourseKj" label="name" value="code" 
                                :initData="initCoursewareDate"  @changePageGetList="changePageGetListKj" :list="coursewareDate" :isMultiple="true" 
                                :paginationOption="paginationOptionKj" :remoteStatus="true" :filterableStatus="true"  @searchValue="searchValueKj"/>
                            </el-form-item>
                        </div>
                        <div class="formItemBox mb-15">
                            <el-form-item label="练习题" prop="enddate">
                                <SelectPage key="4" :listLoading="false" @getSelectValue="getSelectCourseLx" label="name" value="code" 
                                :initData="initTestLxData" @changePageGetList="changePageGetListLx" :list="testPaperOptions" :isMultiple="false" 
                                :paginationOption="paginationOptionLx" :remoteStatus="true" :filterableStatus="true"  @searchValue="searchValueLx" />
                            </el-form-item>
                            <el-form-item label="测验题" prop="examcode">
                                <SelectPage key="5" :listLoading="false" @getSelectValue="getSelectCourseTest" label="name" value="code" 
                                :initData="initTestData"  @changePageGetList="changePageGetListTest" :list="testPaperOptions" :isMultiple="false" 
                                :paginationOption="paginationOptionTest" :remoteStatus="true" :filterableStatus="true" @searchValue="searchValueTest"/>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
            </div>
        </el-scrollbar>
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取消</el-button>
            <el-button :loading="loadingStatus" type="primary" @click="submit('form')">确 定</el-button>
        </span>
    </el-dialog>

</template>
<script>
import {
  getTimeconfigList,
  getQuesBankListBySelect,
  getTeacherList,
  getCourseWareListBySelect,
  getCourseperiodDetails,
  saveCourseperiod,
  getRecordedVideoBySelect
} from '@/api/measApi/teachManagement.js'
import { getTableDefaultPageSize } from '@/assets/measAssets/js/tools.js'
import SelectPage from '@/components/measComponents/selectPage/selectPage'
export default {
  data() {
    return {
      visible: false,
      title: '编辑课时',
      initData: {
        className: '', //班级级名称
        courseName: '',
        courseIndex: ''
      },
      loadingStatus: false,
      timeArr: [],
      form: {
        code: '',
        content: '',
        contentway: '',
        endtime: '',
        examcode: '',
        exercisecode: '',
        perioddate: '',
        periodmode: '',
        periodname: '',
        periodplace: '',
        resourcecode: '',
        resourcename: '',
        starttime: '',
        teachercode: '',
        teachername: '',
        warecode: ''
      },
      rules: {
        periodname: [{ required: true, message: '请输入', trigger: 'blur' }],
        perioddate: [{ required: true, message: '请选择', trigger: 'blur' }],
        begindate: [{ required: true, message: '请选择', trigger: 'blur' }],
        periodmode: [{ required: true, message: '请选择', trigger: 'blur' }],
        contentway: [{ required: true, message: '请选择', trigger: 'change' }],
        exercisecode: [{ required: true, message: '请选择', trigger: 'blur' }]
        // teachername: [
        //     { required: true, message: '请选择', trigger: 'blur' }
        // ],
      },
      paginationOptionCourse: {
        pagesize: 1,
        page: 1,
        total: 0
      },
      paginationOption: {
        pagesize: 1,
        page: 1,
        total: 0
      },
      paginationOptionTeach: {
        pagesize: 1,
        page: 1,
        total: 0
      },
      paginationOptionKj: {
        pagesize: 1,
        page: 1,
        total: 0
      },
      paginationOptionLx: {
        pagesize: 1,
        page: 1,
        total: 0
      },
      paginationOptionTest: {
        pagesize: 1,
        page: 1,
        total: 0
      },
      timeOptions: [],
      quesBankParams: {
        condition: '',
        orderbyname: ''
      },
      courseParams: {
        condition: {
          name: ''
        }
      },
      courseperParams: {
        code: ''
      },
      teachParams: {
        condition: {
          innerid: '',
          orgname: ''
        },
        orderbyname: '',
        orderbyorder: ''
      },
      replayOptions: [],
      CourseOptions: [],
      teachOptions: [],
      testPaperOptions: [],
      initTeacherData: [],
      initTestData: {},
      initTestLxData: {},
      coursewareDate: [],
      initCoursewareDate: [],
      classVideoDate: [],
      initClassVideoDate: [],
      replayClassVideoParams: {
        condition: {
          keyword: '',
          classcoursecode: '',
          ispaging: true
        }
      },
      playUrl: ''
    }
  },
  components: {
    SelectPage
  },
  methods: {
    init(code, classcoursecode) {
      this.visible = true
      this.courseperParams.code = code
      this.form.code = code
      this.replayClassVideoParams.condition.classcoursecode = classcoursecode
      this.getQuesBankListBySelect('type')
      this.getCourseWareListBySelect()
      this.getCourseperiodDetails()
      this.getTimeconfigList()
      this.getTeacherList()
      this.getRecordedVideoBySelect()
    },
    getSelectCourse(value) {},
    getSelectCourseTest(value) {
      this.form.examcode = value[0].code
    },
    getSelectCourseLx(value) {
      this.form.exercisecode = value[0].code
    },
    handleClose() {
      this.visible = false
    },
    // 获取题库下拉（练习题，测验题）
    getQuesBankListBySelect(type) {
        let tmpPageObj = {}
        if(type){
            tmpPageObj = this.paginationOptionLx
        }else{
            tmpPageObj = this.paginationOptionTest
        }
      getQuesBankListBySelect(
        Object.assign(tmpPageObj, this.quesBankParams)
      ).then(res => {
        this.testPaperOptions = res.data
        this.paginationOptionLx.total = res.pageinfo.rowcount
        this.paginationOptionTest.total = res.pageinfo.rowcount
        console.log(res, '试卷下拉')
      })
    },
    // 练习题分页
    changePageGetListLx(page){
        this.paginationOptionLx.page = page
        this.getQuesBankListBySelect('type')
    },
    //练习题搜索
    searchValueLx(value){
        this.paginationOptionLx.page = 1
        this.quesBankParams.condition = value
        this.getQuesBankListBySelect('type')
    },
    // 测验题分页
    changePageGetListTest(page){
        this.paginationOptionTest.page = page
        this.getQuesBankListBySelect()
    },
    //测验题搜索
    searchValueTest(value){
        console.log(value,'sasasasa')
        this.paginationOptionTest.page = 1
        this.quesBankParams.condition = value
        console.log( this.quesBankParams,' this.quesBankParams')
        this.getQuesBankListBySelect()
    },
    // 获取课件下拉(接口error)
    getCourseWareListBySelect() {
      getCourseWareListBySelect(
        Object.assign(this.courseParams, this.paginationOptionKj)
      ).then(res => {
        this.paginationOptionKj.total = res.pageinfo.rowcount
        this.coursewareDate = res.data
        console.log(res, '课件下拉')
      })
    },
    // 选择课件
    getSelectCourseKj(value) {
      console.log(value, '课件')
      this.form.warecode = value[0].code
    },
    // 课件分页
    changePageGetListKj(page){
        this.paginationOptionKj.page = page
        this.getCourseWareListBySelect()
    },
    //课件搜索
    searchValueKj(value){
        this.courseParams.condition.name = value
        this.paginationOptionKj.page = 1
        this.getCourseWareListBySelect()
    },
    // 获取录播课程下拉
    getRecordedVideoBySelect() {
      getRecordedVideoBySelect(
        Object.assign(this.paginationOptionCourse, this.replayClassVideoParams)
      ).then(res => {
        this.classVideoDate = res.data
        this.paginationOptionCourse.total = res.pageinfo.rowcount
        console.log(res, '录播下拉')
      })
    },
    // 获取录播课程code
    getSelectClassVideo(value) {
      this.form.resourcename = value[0].name
      this.form.resourcecode = value[0].code
      this.playUrl = value[0].classcourseurl
      if (!this.form.periodname) {
        this.form.periodname = value[0].name
      }
    },
    // 切换录播分页
    changePageGetListVideo(page){
        this.paginationOptionCourse.page = page
        this.getRecordedVideoBySelect()
    },
    // 录播搜索
    searchValueVideo(value){
        this.paginationOptionCourse.page = 1
        this.replayClassVideoParams.condition.keyword = value
        this.getRecordedVideoBySelect()
    },
    // 获取课时信息
    getCourseperiodDetails() {
      getCourseperiodDetails(this.courseperParams).then(res => {
        this.initData.className = res.data.classname
        this.initData.courseName = res.data.classcoursename
        this.initData.courseIndex = res.data.periodindex
        this.form.periodname = res.data.periodname
        this.form.perioddate = res.data.perioddate
        this.form.endtime = res.data.endtime
        this.form.starttime = res.data.starttime
        this.form.periodmode = res.data.periodmode
        this.form.contentway = res.data.contentway
        this.form.resourcename = res.data.resourcename
        this.form.resourcecode = res.data.resourcecode
        // 初始化录播信息
        this.initClassVideoDate = {
          name: res.data.resourcename,
          code: res.data.resourcecode,
          classcourseurl: res.data.classcourseurl
        }
        this.playUrl = res.data.classcourseurl
        this.form.teachername = res.data.teachername
        this.form.teachercode = res.data.teachercode
        this.form.content = res.data.content
        this.form.warecode = res.data.warecode
        this.form.exercisecode = res.data.exercisecode
        // this.form.exercisename = res.data.exercisename
        // this.form.examname = res.data.examname
        this.form.examcode = res.data.examcode
        // 课件初始化
        // this.form.warename = res.data.warename
        this.form.warecode = res.data.warecode

        if (res.data.warename) {
          let tmpArr = []
          let warecodeArr = res.data.warecode.split(',')
          let warenameArr = res.data.warename.split(',')
          warecodeArr.forEach((item, idx) => {
            tmpArr.push({
              name: warenameArr[idx],
              code: item
            })
          })
          this.initCoursewareDate = tmpArr
        }
        // 老师初始化
        if (res.data.teachername) {
          let tmpTeachArr = []
          let teachernameArr = res.data.teachername
            ? res.data.teachername.split(',')
            : ''
          let teachercodeArr = res.data.teachercode
            ? res.data.teachercode.split(',')
            : ''
          teachernameArr.forEach((item, index) => {
            tmpTeachArr.push({
              orgname: item,
              code: teachercodeArr[index]
            })
          })
          this.initTeacherData = tmpTeachArr
        }
        // 练习题初始化
        if (res.data.exercisename) {
          this.initTestLxData = {
            name: res.data.exercisename,
            code: res.data.exercisecode
          }
        }
        // 测试题初始化
        if (res.data.examname) {
          this.initTestData = {
            name: res.data.examname,
            code: res.data.examcode
          }
        }

        let tmpArr = []
        this.form.starttime.split(',').forEach((item, index) => {
          this.form.endtime.split(',').forEach((res, idx) => {
            if (index === idx) {
              tmpArr.push(item + '-' + res)
            }
          })
        })
        this.timeArr = tmpArr
        console.log(res, '课时信息')
      })
    },
    // 获取时间段下拉
    getTimeconfigList() {
      getTimeconfigList(this.timeParams).then(res => {
        console.log(res, '时间段下拉')
        let arr = JSON.parse(JSON.stringify(res.data))
        arr.forEach(element => {
          element.timeStr = element.starttime + '-' + element.endtime
        })
        this.timeOptions = arr
      })
    },
    getTimes(code) {
      console.log(code, 'code')
      let starStr = []
      let endStr = []
      this.timeOptions.forEach(item => {
        code.forEach(itm => {
          if (item.code === itm) {
            starStr.push(item.starttime)
            endStr.push(item.endtime)
          }
        })
      })
      this.form.starttime = starStr.toString()
      this.form.endtime = endStr.toString()
    },
    // 获取老师下拉
    getTeacherList() {
      getTeacherList(
        Object.assign(this.teachParams, this.paginationOptionTeach)
      ).then(res => {
        this.teachOptions = res.data
        this.paginationOptionTeach.total = res.pageinfo.rowcount
        // this.initTeacherData = this.teachOptions.filter(item => {
        //     return item.code === this.form.teachercode
        // })
        console.log(res, '老师')
      })
    },
    // 获取老师code
    getSelectValue(value) {
        console.log(value,'value')
      let arrName = []
      let arrCode = []
      value.forEach(item => {
        arrName.push(item.orgname)
        arrCode.push(item.code)
      })
      this.form.teachercode = arrCode.toString()
      this.form.teachername = arrName.toString()
      // console.log(value,'老师code')
    },
    // 切换老师分页
    changePageGetListTeach(page){
        this.paginationOptionTeach.page = page
        this.getTeacherList()
    },
    submit(formName) {
      console.log(this.form, 'asdasdasda')
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.saveCourseperiod()
          this.loadingStatus = true
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    saveCourseperiod() {
      try {
        saveCourseperiod(this.form).then(res => {
          this.loadingStatus = false
          if (res.code === '000') {
            this.$message.success(res.msg)
            this.$parent.init()
            this.visible = false
          } else {
            this.$message.error(res.msg)
          }
        })
      } catch (error) {
        this.loadingStatus = false
        this.$message.error('网络出错')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-depp .is-vertical {
  min-width: none !important;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
::v-deep .el-scrollbar__bar {
  display: none;
}
.scheduleConte {
  > .el-scrollbar__wrap {
    padding: 0 !important;
  }
  .formContent {
    padding: 20px;
  }
  .ylBtn {
    height: 36px;
    line-height: 36px;
    background: #409eff;
    color: white;
    text-align: center;
    padding: 0 20px;
    cursor: pointer;
    border-radius: 4px;
    margin-top: 30px;
    margin-left: 10px;
  }
}
</style>